import React from 'react';

import { Col, Paper, Row } from 'redpoints-front-components/index';

import FacilitatorValidationFiltersActions from './FacilitatorValidationFiltersActions';
import FacilitatorValidationFiltersCustomer from './FacilitatorValidationFiltersCustomer';
import FacilitatorValidationFiltersDomain from './FacilitatorValidationFiltersDomain';

const FacilitatorValidationFilters = ({ isEnableFilterByTenant }) => {
  return (
    <Paper className="facilitator-validation-filters">
      <Row gutter={16}>
        <Col xl={10} md={12}>
          <FacilitatorValidationFiltersCustomer
            isEnableFilterByTenant={isEnableFilterByTenant}
          />
        </Col>
        <Col xl={8} md={12}>
          <FacilitatorValidationFiltersDomain />
        </Col>
        <Col xl={6} md={12} align="right">
          <FacilitatorValidationFiltersActions />
        </Col>
      </Row>
    </Paper>
  );
};

export default FacilitatorValidationFilters;
